export const getIdFromPath = (path) => {
  const pathArray = path.split("/");
  return pathArray[pathArray.length - 1];
};
